// Field projection for owned `campaignComponent` objects. The projection maps
// output-shape fields (sourcePath) to input-shape fields (inputField); some are
// `.id` extractions. On create the projected fields are flattened onto the parent
// object (replacing the old hardcoded `campaignComponent` branch).
export const campaignComponentProject = {
    type: 'create' as const,
    project: {
        qty: 'qty',
        region_id: 'region.id',
        region_type_id: 'regionType.id',
        unit_value_local: 'unit_value_local',
        price_divisor: 'price_divisor',
        currency_id: 'currency.id',
        unit_value_estimated_local: 'unit_value_estimated_local',
        unit_value_actual: 'unit_value_actual'
    }
};

export const fieldMappings = {
    'costs': 'create',
    'costs.currency': 'connect',
    'costs.costSupplier': 'connect',
    areaBookings: 'create',
    'regionalAmAllocation':'connect',
    'areaBookings.areaBookingItems.campaignComponent.region': 'connect',
    'areaBookings.areaBookingItems.campaignComponent.currency': 'connect',
    'areaBookings.posterSize': 'connect',
    'areaBookings.regionType': 'connect',
    'areaBookings.currency': 'connect', 
    'areaBookings.areaBookingItems': 'create',
    'areaBookings.areaBookingItems.distributor': 'connect',
    'areaBookings.areaBookingItems.areaBookingZone': 'connect',
    'clientCompany': 'connect',
    'clientCompanyContact': 'connect',
    'clientSubType': 'connect',
    'currency': 'connect',
    'currencies': 'connect',
    'mediaProductions': 'create',
    'mediaProductions.mediaType': 'connect',
    'mediaProductions.size': 'connect',
    'mediaProductions.campaignComponent.currency': 'connect',
    'creativeStudio': 'create',
    'creativeStudio.creativeStudioType': 'connect',
    'creativeStudio.campaignComponent.region': 'connect',
    'creativeStudio.campaignComponent.regionType': 'connect',
    'creativeStudio.creativeStudioTypeDetail': 'connect',
    'creativeStudio.campaignComponent.currency': 'connect',
    'experientials.experientialType': 'connect',
    'experientials.campaignComponent.region': 'connect',
    'experientials.campaignComponent.regionType': 'connect',
    'experientials.campaignComponent.currency': 'connect',
    'ambients.ambientType': 'connect',
    'ambients.campaignComponent.region': 'connect',
    'ambients.campaignComponent.currency': 'connect',
    'sundries.sundryType': 'connect',
    'sundries.campaignComponent.regionType': 'connect',
    'sundries.campaignComponent.region': 'connect',
    'sundries.campaignComponent.currency': 'connect',
    'ourContact': 'connect',
    'panelBookings': 'create', // trash
    'salesTeam': 'connect',
    'previewTags':'connect',
    'paymentTerms':'connect',
    'artworkFiles.distributor': 'connect',
    'contractSections': 'create',
    'contractSections.blocks': 'create',
    'contractSections.blocks.files.distributor': 'connect',
    // owned campaignComponent objects - projected (flattened onto the parent on create)
    'areaBookings.areaBookingItems.campaignComponent': campaignComponentProject,
    'mediaProductions.campaignComponent': campaignComponentProject,
    'creativeStudio.campaignComponent': campaignComponentProject,
    'creativeStudioEntries.campaignComponent': campaignComponentProject,
    'experientials.campaignComponent': campaignComponentProject,
    'ambients.campaignComponent': campaignComponentProject,
    'sundries.campaignComponent': campaignComponentProject,
    // transient/derived fields - stripped from the payload by the diff engine
    'outboundChallenges': 'transient',
    'inboundChallenges': 'transient',
    'components': 'transient',
    'totalCost': 'transient',
    'discountableTotal': 'transient',
    'undiscountableTotal': 'transient',
    'photoPaidTotal': 'transient',
    'tempFiles': 'transient',
    '__cloned': 'transient',
    'job_reference': 'transient',
    'campaignExchangeRates': 'transient',
    'created_at': 'transient',
    'areaBookings.total_value': 'transient',
    'areaBookings.num_posters': 'transient',
    'areaBookings.first_up': 'transient',
    'areaBookings.last_down': 'transient',
    'areaBookings.areaBookingItems.created_at': 'transient'
};